<template>
  <gj-modal
      :visible.sync="modalVisible"
      :confirm-loading="loading"
      size="normal"
      @cancel="cancel"
      @confirm="confirm"
  >
    <template #header>更换手机</template>
    <template #content>
      <div style="padding: 0 10px">
        <gj-alert border show-icon class="gj-mb10">为了保证您的账号安全，更换前需要验证身份信息</gj-alert>
        <el-form
            :model="form"
            label-width="120px"
            ref="form"
            label-position="top"
        >
          <el-form-item
              prop="phone"
              label="验证旧手机"
              style="margin-bottom: 5px"
          >
            <gj-input width="245px" v-model="phone" readonly></gj-input>
          </el-form-item>
          <el-form-item
              prop="code"
              label="验证码"
              :rules="[
              {required: true, message: '请输入验证码', trigger: ['blur', 'change']},
            ]"
              style="margin-bottom: 6px"
          >
            <gj-input placeholder="请输入验证码" style="margin-right: 10px" width="144px" v-model="form.code"></gj-input>
            <gj-button
                plain
                type="ghost"
                size="mini"
                class="v-code"
                :disabled="registerCaptchaDisabled"
                @click="registerCaptcha()">
              <template v-if="registerCaptchaDisabled">
                {{registerCaptchaTime}}s后重发
              </template>
              <template v-else>
                获取验证码
              </template>
            </gj-button>
          </el-form-item>
          <el-form-item>
            <div>手机不再使用？<gj-button type="text" style="padding: 0">请联系客服</gj-button></div>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, modalMixIn} from "../../../../minxins";
  import {checkOldPhoneCaptcha, updateOldPhoneCaptcha} from "../../../../api/personal-center";
  import { tcAuthCode } from "@/utils/common";
  export default {
    name: "validator-phone",
    mixins: [modalMixIn, formRuleMixin],
    props: {
      phone: {
        require: true,
      }
    },
    data() {
      return {
        loading: false,
        form: {
          code: null,
        },
        registerCaptchaDisabled: false,
        registerCaptchaTime: null,
      }
    },
    methods: {
      registerCaptcha() {
        tcAuthCode(this.phone).then(resolve => {
          updateOldPhoneCaptcha({mobile: this.phone, code:resolve});
          this.registerCaptchaDisabled = true;
          this.registerCaptchaTime = 120;
          const intervalHandle = setInterval(() => {
            if (this.registerCaptchaTime > 0) {
              this.registerCaptchaTime--;
            } else {
              this.registerCaptchaDisabled = false;
              clearInterval(intervalHandle);
            }
          }, 1000);
        }).catch(error => {})
      },
      confirm() {
        if (this.$gjFormValidate()) {
          this.loading = true;
          checkOldPhoneCaptcha(this.form.code, this.phone)
            .then((res) => {
              if (res.code !== 0) {
                this.$message.error(res.msg);
              } else {
                this.$emit('after');
              }
            }).complete(() => this.loading = false)
        }
      }
    }
  }
</script>

<style scoped>
  /deep/ .gj-modal--normal .el-dialog {
    width: 420px;
  }
  /deep/ .el-form--label-top .el-form-item__label {
    float: none;
    display: initial;
    text-align: left;
    padding: 0 0 10px 0;
  }
</style>
